export default __webpack_public_path__ + "static/media/bronder.36cfcb25.png";